/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './requestEmailConfirmation.defs.js'
export { main as default } from './requestEmailConfirmation.defs.js'
